import { z as zod } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';

const schema = zod.object({
  address: zod.string().min(1, { message: 'Click connect wallet' }),
  pw: zod.string().min(1, { message: 'Password is required' }),
});

type Values = zod.infer<typeof schema>;

const defaultValues = { pw: '', address: '' } satisfies Values;

export default function Dashboard() {
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  return <>Dashboard</>;
}
